import { render, staticRenderFns } from "./BaseChipsInput.vue?vue&type=template&id=9bad9b3c&"
import script from "./BaseChipsInput.vue?vue&type=script&lang=js&"
export * from "./BaseChipsInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports